import { Toast } from 'vant';
import { detectEnv } from './detect';
import { RUNTIME_ENV } from '@/config';

interface BridgeRequest {
  action: string;
  params?: Record<string, any> | any;
}

/**
 * 调用JSBridge
 * @param {Object} data
 * @param {Object} data.action 需要调用的方法名
 */

function invoke(data: BridgeRequest): void {
  // 如果不在APP中则提示用户

  let res = null;
  if (!detectEnv.webview) {
    if (process.env.NODE_ENV === 'development') {
      return;
    }
    // Toast.fail('Por favor, realice la operación en la aplicación');
    return;
  }

  // 测试环境和开发环境增加调试信息
  if (RUNTIME_ENV !== 'prod') {
    console.info(`jsbridge request: ${JSON.stringify(data, null, '  ')}`);
  }

  if (detectEnv.android) {
    try {
      if (data.params) {
        res = window.OraleJavaScript[data.action](data.params);
      } else {
        res = window.OraleJavaScript[data.action]();
        console.log(res, 'res');
      }
    } catch (e: any) {
      Toast.fail(`jsbridge error: ${e.message}`);
    }
  }
  return res;
}

function delAccountSus() {
  return invoke({
    action: 'delAccountSus',
  });
}

function takeOcrPhoto() {
  return invoke({
    action: 'takeOcrPhoto',
  });
}

function faceAuth(params: '0' | '1') {
  return invoke({
    action: 'faceAuth',
    params,
  });
}

// function localAppVer() {
//   return invoke({
//     action: 'localAppVer',
//   });
// }

function locUserToken() {
  return invoke({
    action: 'locUserToken',
  });
}

function uploadFinaceSms() {
  return invoke({
    action: 'uploadFinaceSms',
  });
}

function loadBlackBox() {
  return invoke({
    action: 'loadBlackBox',
  });
}

function webOccupationBack(params: '0' | '1') {
  return invoke({
    action: 'webOccupationBack',
    params,
  });
}

function jumpLocalHomePage() {
  return invoke({
    action: 'jumpLocalHomePage',
  });
}

// function loadLocalUserInfo() {
//   return invoke({
//     action: 'loadLocalUserInfo',
//   });
// }

// function loadLocalId() {
//   return invoke({
//     action: 'loadLocalId',
//   });
// }

function closeHostWeb() {
  return invoke({
    action: 'closeHostWeb',
  });
}

function reportWebData(params: string) {
  return invoke({
    action: 'reportWebData',
    params,
  });
}

function loadCommonPointData() {
  return invoke({
    action: 'loadCommonPointData',
  });
}

function loadAdjustChannel() {
  return invoke({
    action: 'loadAdjustChannel',
  });
}

function loadGaid() {
  return invoke({
    action: 'loadGaid',
  });
}

export default {
  invoke,
  delAccountSus,
  takeOcrPhoto,
  faceAuth,
  // localAppVer,
  locUserToken,
  uploadFinaceSms,
  loadBlackBox,
  webOccupationBack,
  jumpLocalHomePage,
  // loadLocalUserInfo,
  // loadLocalId,
  closeHostWeb,
  reportWebData,
  loadCommonPointData,
  loadAdjustChannel,
  loadGaid,
};
